import { render, staticRenderFns } from "./ShopView.vue?vue&type=template&id=3e825898"
import script from "./ShopView.vue?vue&type=script&lang=js"
export * from "./ShopView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports